import {
	LOGOUT,
	REHYDRATE,
	GET_CHATS,
	GET_CHATS_H,
	GET_CHAT_DETAILS,
	SET_SEARCH_IN_CHAT,
	CLEAR_SEARCH_IN_CHAT,
	SET_CURRENT_CHAT,
	TAKE_CHAT,
	FREE_CHAT,
	CLOSE_CHAT,
	TAG_CHAT,
	SHEDULE_CHAT,
	TRANSFER_CHAT,
	GET_REMAINING_MESSAGES,
	SET_REPLY,
	REMOVE_REPLY,
	RECEIVE_MESSAGE,
	MESSAGE_LOCAL,
	MESSAGE_SENT,
	CHAT_TAKEN,
	CHAT_FREED,
	CHAT_TRANSFERRED,
	CHAT_CLOSED,
	UPDATE_CHAT,
	TOGGLE_VIEW_AUTOGESTION,
	UPDATE_CONTACT,
} from "@Actions/types";
import { map, unionBy, some, reject, isEmpty, has, isArray, uniqBy, filter } from "lodash";
import { sanitizeMessagesForPersist } from "@Utils";

export default function reducer(
	state = {
		chats: [],
		messages: [],
		currentChatId: 0,
		reply: {},
		isSearchEnabled: false,
		isViewAutogestion: false,
	},
	action
) {
	const { type, payload } = action;
	switch (type) {
		case LOGOUT: {
			return {
				...state,
				chats: [],
				messages: [],
				currentChatId: 0,
				reply: {},
				isSearchEnabled: false,
				isViewAutogestion: false,
			};
		}

		case REHYDRATE: {
			return {
				...state,
				chats: payload.data.chats.chats,
				messages: sanitizeMessagesForPersist(payload.data.chats.messages),
				currentChatId: payload.data.chats.currentChatId,
				reply: payload.data.chats.reply,
				isSearchEnabled: payload.data.chats.isSearchEnabled,
				isViewAutogestion: payload.data.chats.isViewAutogestion,
			};
		}

		case SET_SEARCH_IN_CHAT: {
			return {
				...state,
				isSearchEnabled: true,
				reply: {},
			};
		}

		case CLEAR_SEARCH_IN_CHAT: {
			return {
				...state,
				isSearchEnabled: false,
				reply: {},
			};
		}

		case TOGGLE_VIEW_AUTOGESTION: {
			return {
				...state,
				isViewAutogestion: !state.isViewAutogestion,
			};
		}

		case SET_CURRENT_CHAT: {
			if (!payload.data.isHistoric) {
				return {
					...state,
					chats: map(state.chats, (item) => {
						if (item.id === payload.data.chatId) return { ...item, count: 0 };
						return item;
					}),
					currentChatId: payload.data.chatId,
					reply: {},
					isSearchEnabled: false,
				};
			}
			return { ...state };
		}

		case GET_CHATS: {
			const channelCids = new Set(
				map(payload.data.chats, (item) => {
					return item.channelCid;
				})
			);
			const preservedMessages = filter(state.messages, (item) => {
				return channelCids.has(item.channelCid);
			});
			const previewMessages = map(payload.data.messages, (item) => {
				return { ...item, status: "read" };
			});
			return {
				...state,
				chats: map(payload.data.chats, (item) => {
					const existing = state.chats.find((chat) => {
						return chat.id === item.id;
					});
					return {
						...item,
						hasFetched: existing?.hasFetched ?? false,
						endFetching: existing?.endFetching ?? false,
						count: 0,
					};
				}),
				messages: unionBy(previewMessages, preservedMessages, "id"),
			};
		}

		case GET_CHATS_H: {
			return {
				...state,
				isSearchEnabled: false,
				reply: {},
			};
		}

		case GET_CHAT_DETAILS: {
			if (!payload.data.isHistoric) {
				return {
					...state,
					chats: map(state.chats, (item) => {
						if (item.id === payload.data.chat.id) return { ...item, ...payload.data.chat };
						return item;
					}),
				};
			}
			return state;
		}

		case UPDATE_CHAT: {
			return {
				...state,
				currentChatId: has(payload.data, "current")
					? payload.data.current === "remove"
						? 0
						: payload.data?.chat?.id
					: state.currentChatId,
				chats: map(state.chats, (item) => {
					if (item.id === payload.data?.chat?.id) return { ...item, ...payload.data.chat };
					return item;
				}),
				messages: unionBy(payload.data.messages || [], state.messages, "id"),
			};
		}

		case TAKE_CHAT: {
			return {
				...state,
				chats: map(state.chats, (item) => {
					if (item.id === payload.data.chat.id) return { ...item, ...payload.data.chat, count: 0 };
					return item;
				}),
				messages: unionBy(payload.data.messages, state.messages, "id"),
				currentChatId: payload.data.chat.id,
				reply: {},
			};
		}

		case TAG_CHAT: {
			return {
				...state,
				chats: map(state.chats, (item) => {
					if (item.id === payload.data.id) return { ...item, ...payload.data };
					return item;
				}),
			};
		}

		case FREE_CHAT: {
			return {
				...state,
				chats: map(state.chats, (item) => {
					if (item.id === payload.data.id) return { ...item, ...payload.data };
					return item;
				}),
				currentChatId: 0,
				reply: {},
			};
		}

		case SHEDULE_CHAT:
		case CLOSE_CHAT: {
			return {
				...state,
				chats: reject(state.chats, { channelCid: payload.data }),
				messages: reject(state.messages, { channelCid: payload.data }),
				currentChatId: 0,
				reply: {},
			};
		}

		case GET_REMAINING_MESSAGES: {
			if (!payload.data.isHistoric) {
				const mergedMsgs = unionBy(state.messages, payload.data.messages, "id");
				const mappedMsgs = map(mergedMsgs, (item) => {
					return { ...item, status: "read" };
				});
				const mappedChats = map(state.chats, (item) => {
					if (item.id === payload.data.chatId) return { ...item, hasFetched: true, endFetching: isEmpty(payload.data.messages) };
					return item;
				});
				return {
					...state,
					chats: mappedChats,
					messages: mappedMsgs,
				};
			}
			return { ...state };
		}

		case SET_REPLY: {
			return {
				...state,
				reply: payload.data,
			};
		}

		case REMOVE_REPLY: {
			return {
				...state,
				reply: {},
			};
		}

		case RECEIVE_MESSAGE: {
			const convExists = some(state.chats, (item) => {
				return item.id === payload.data.chat.id || item.contactId === payload.data.chat.contactId;
			});
			const rawMsgs = isArray(payload.data.message) ? payload.data.message : [payload.data.message];
			const incomingMsgs = map(rawMsgs, (item) => {
				return { ...item, status: "read" };
			});
			const mergeMessages = (existing) => {
				const updated = map(existing, (msg) => {
					const incoming = incomingMsgs.find((n) => {
						return n?.id != null && String(n.id) === String(msg.id);
					});
					return incoming ? { ...msg, ...incoming } : msg;
				});
				const brandNew = incomingMsgs.filter((n) => {
					return (
						n?.id != null &&
						!some(existing, (m) => {
							return String(m.id) === String(n.id);
						})
					);
				});
				return [...brandNew, ...updated];
			};

			if (convExists) {
				const mappedChats = map(state.chats, (item) => {
					if (item.id === payload.data.chat.id || item.contactId === payload.data.chat.contactId)
						return {
							...item,
							...payload.data.chat,
							count: state.currentChatId === item.id ? 0 : item.count + 1,
						};
					return item;
				});
				return {
					...state,
					chats: mappedChats,
					messages: mergeMessages(state.messages),
				};
			}
			const newChat = {
				...payload.data.chat,
				hasFetched: false,
				endFetching: false,
				count: state.currentChatId === payload.data.chat.id ? 0 : 1,
			};
			return {
				...state,
				chats: unionBy([newChat], state.chats, "id"),
				messages: mergeMessages(state.messages),
			};
		}

		case MESSAGE_LOCAL: {
			const newMsg = { ...payload.data, status: "local" };
			return {
				...state,
				messages: unionBy([newMsg], state.messages, "id"),
				reply: {},
			};
		}

		case MESSAGE_SENT: {
			const mappedChats = map(state.chats, (item) => {
				if (item.id === payload.data.chat.id) return { ...item, ...payload.data.chat };
				return item;
			});
			const mappedMessages = map(state.messages, (item) => {
				if (item.id === payload.data.tempId) return { ...item, ...payload.data.message, status: "read" };
				return item;
			});
			return {
				...state,
				chats: uniqBy(mappedChats, "id"),
				messages: uniqBy(mappedMessages, "id"),
			};
		}

		case CHAT_CLOSED: {
			return {
				...state,
				chats: reject(state.chats, { channelCid: payload.data.channelCid }),
				messages: reject(state.messages, { channelCid: payload.channelCid }),
			};
		}

		case CHAT_TAKEN:
		case TRANSFER_CHAT: {
			return {
				...state,
				chats: reject(state.chats, { channelCid: payload.data.chat.channelCid }),
				messages: reject(state.messages, { channelCid: payload.data.chat.channelCid }),
				currentChatId: payload.data.withRemoveCurrent ? 0 : state.currentChatId,
				reply: payload.data.withRemoveCurrent ? {} : state.reply,
			};
		}

		case CHAT_FREED:
		case CHAT_TRANSFERRED: {
			const newChat = {
				...payload.data.chat,
				hasFetched: false,
				endFetching: false,
				count: state.currentChatId === payload.data.chat.id ? 0 : 1,
			};
			const newMsgs = map(payload.data.messages, (item) => {
				return { ...item, status: "read" };
			});
			return {
				...state,
				chats: unionBy([newChat], state.chats, "id"),
				messages: unionBy(newMsgs, state.messages, "id"),
			};
		}

		case UPDATE_CONTACT: {
			return {
				...state,
				chats: map(state.chats, (item) => {
					if (item.contactId === payload.data.id) {
						return { ...item, contact: payload.data };
					}
					return item;
				}),
			};
		}

		default:
			return state;
	}
}
